module.exports = __webpack_public_path__ + "static/media/dth.c0293ed1.png";